import { useEffect, useState } from "react";
import { serverError, useI18n } from "../i18n";

/**
 * 管理後台的資料取得。
 * 刻意極簡 —— 管理後台的頁面少、互動單純，不需要完整的快取層。
 */
export function useAdminApi<T>(path: string, deps: unknown[] = []) {
  const { t } = useI18n();
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch(`/api${path}`, { credentials: "same-origin" })
      .then(async (res) => {
        const payload = await res.json().catch(() => null);
        if (!res.ok) throw new Error(serverError(payload, t, `HTTP ${res.status}`));
        return payload.data as T;
      })
      .then((result) => !cancelled && setData(result))
      .catch((e: Error) => !cancelled && setError(e.message))
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, error, loading };
}
